<template>
    <section>
        <el-card class="wrap">
            <el-form label-width="100px">
                <el-form-item label="榜单名称" class="is-required">
                    <el-input
                        placeholder="请输入..."
                        v-model.trim="info.name"
                        maxlength="30"
                        show-word-limit
                        class="input-width"></el-input>
                    <span style="color: grey; font-size: 13px">30个字以内</span>
                </el-form-item>
                <el-form-item label="封面" class="is-required">
                    <el-upload
                        class="avatar-uploader" 
                        :action="commonUrl.uploadImg" 
                        :headers="commonUrl.headers"
                        :data="mediaObj" 
                        :multiple="false" 
                        accept="image/png, image/jpg, image/jpeg, image/gif"
                        :show-file-list="false"
                        :on-success="uploadSuccess">
                        <div v-if="info.coverImg" class="avatar trash">
                            <img :src="commonUrl.imgPrefix + info.coverImg" />
                            <div class="trashdom"></div>
                            <i class="el-icon-delete avatar_edit" @click.stop="deleteCover('coverImg')"></i>
                        </div>
                        <i v-else class="iconfont icon-picture-add"></i>
                    </el-upload>
                    <span style="color:grey;font-size:13px;">支持格式png/jpg/GIF，尺寸750*235；不超过500kb</span>
                </el-form-item>
                <el-form-item label="推荐语" class="is-required">
                    <el-input
                        type="textarea"
                        placeholder="请输入..." 
                        v-model.trim="info.description" 
                        maxlength="200"
                        show-word-limit
                        class="input-width"></el-input>
                    <span style="color: grey; font-size: 13px">200个字以内</span>
                </el-form-item>
                <el-form-item label="所属学科" class="is-required">
                    <el-checkbox-group v-model="info.disciplineIds">
                        <el-checkbox
                         v-for="(item, index) in disciplineList"
                         :key="index"
                         :label="item.id"
                         name="id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="权重">
                    <el-input-number
                        v-model="info.weight"
                        :min="0"
                        :max="999999"
                        size="small"
                        :precision="0"
                        label="请输入...">
                    </el-input-number>
                    <span style="color: grey; font-size: 13px">6位数以内</span>
                </el-form-item>
                <el-form-item label-width="100px">
                    <el-button type="primary" :loading="saveLock"
                    :disabled="saveLock" @click="save">保存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-card class="wrap" style="margin-top: 20px; padding-bottom: 20px;"
         v-if="rankId">
            <el-button type='primary' size='small' @click='openCourse'>
                <i class="iconfont icon-add"></i>添加课程
            </el-button>
            <el-table class='table_list' :data="courseList"
                border style="width: 100%" highlight-current-row>
                <el-table-column label="排行"
                  width="154px">
                    <template slot-scope="scope">
                        <el-input-number
                            v-model="scope.row.sortIndex"
                            :min="1"
                            :max="99999"
                            size="small"
                            :precision="0"
                            label="请输入..."
                            @change="(currentValue, oldValue) => change(currentValue, oldValue, scope.row)">
                        </el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="课程名称" prop="courseTitle"
                  width="140px">
                </el-table-column>
                <el-table-column label="课程栏目" prop="subjectNames"
                  min-width="10%">
                </el-table-column>
                <el-table-column label="所属学科" prop="disciplineNames"
                  min-width="10%">
                </el-table-column>
                <el-table-column label="讲师" prop="teacherName"
                  min-width="10%">
                </el-table-column>
                <el-table-column label="销售价"
                  min-width="10%">
                    <template slot-scope="scope">
                        <span>
                         {{scope.row.price | priceFilter}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="加入学习人数" prop="memberCount"
                  min-width="10%">
                </el-table-column>
                <el-table-column label="添加人" prop="createBy"
                  min-width="10%">
                </el-table-column>
                <el-table-column label="添加时间" prop="createTime"
                  width="110px">
                </el-table-column>
                <el-table-column label="操作"
                   width="120px">
                   <template slot-scope="scope">
                        <el-link type="danger"
                     @click="remove(scope.row)">删除</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <!--选择课程组件-->
        <course-select ref='courseRelate' :isSingle='false'
            @select-submit='choiceCourseCallback'></course-select>
    </section>
</template>

<script scoped>
import { commonUrl } from '@/api/common'
import requestApi from '@/api/operateManage/courseRank'
import courseSelect from '@/components/selectSource/selectDocOrMomCourse'
export default {
    components: {
        courseSelect
    },
    data() {
        return {
            commonUrl: commonUrl,
            mediaObj: {
                mediaJson: JSON.stringify({
                    type: 0
                })
			},
            rankId: '',
            info: {
                name: '',
                coverImg: '',
                description: '',
                weight: '',
                disciplineIds: []
            },
            courseList: [],
            disciplineList: [],
            saveLock: false
        }
    },
    props: {
        PAGEKEY: {
            type: String,
            default: () => ''
        }
    },
    activated() {
        if (this.$route.params.id === this.rankId) {
            return
        }
        // 设置课程源信息
        this.rankId = this.$route.params.id
        if (this.rankId) {
            this.getDetail().then(res => {
                res.Data.disciplineIds = res.Data.disciplineIds || []
                this.info = res.Data
                this.courseList = res.Data.courses
            })
        }
    },
    mounted() {
        this.getDisciplineList()
    },
    methods: {
        getDetail() {
            return new Promise((resolve, reject) => {
                let data = {
                    id: this.rankId
                }
                requestApi.getDetail(data).then(res => {
                    if(res.Success){
                        resolve(res)
                    }else{
                        reject()
                        this.$message.error(res.Msg)
                    }
                }).catch(res => {
                    this.$message.error('获取列表出错，请稍后再试')
                })
            })
        },
        // 获取学科列表
        getDisciplineList() {
            requestApi.getDisciplineList({
                status: 1
            }).then(res => {
                if (res.Success) {
                    this.disciplineList = this.disciplineList.concat(res.Data.result || [])
                } else {
                    this.$message.error(res.Msg)
                }
            })
        },
        relation(courseList) {
            if(!courseList.length) {
                this.$message.success('添加完成')
                return
            }
            let course = courseList.pop()
            let data = {
                id: this.rankId,
                courseId: course.id
            }
            requestApi.relation(data).then(res => {
                if(res.Success){
                    this.getDetail().then(res => {
                        this.courseList = res.Data.courses
                    })
                }else{
                    this.$message.error(res.Msg)
                }
            }).catch(res => {
                this.$message.error(new Error(res))
            }).finally(() => {
                this.relation(courseList)
            })
        },
        uploadSuccess(e) {
            e = this.$apiOldResDeal(e)
            if(e.Success) {
                this.info.coverImg = e.Data.url
            } else {
                this.$message.error(res.Msg)
            }
        },
        save() {
            if (!this.info.name) {
                this.$message.warning('请输入榜单名称')
                return
            } else if (!this.info.coverImg) {
                this.$message.warning('请上传封面')
                return
            } else if (!this.info.description) {
                this.$message.warning('请输入推荐语')
                return
            } else if (!this.info.disciplineIds.length) {
                this.$message.warning('请选择至少一门学科')
                return
            }
            if(this.info.disciplineIds.length) {
                let isSelectOn = false // 是否选择了上架的学科
                for(let i = 0; i < this.info.disciplineIds.length; i++) {
                    let disciplineId = this.info.disciplineIds[i]
                    let flag = this.disciplineList.some(item => item.id === disciplineId)
                    if(flag) {
                        isSelectOn = true
                        break
                    }
                }
                if(!isSelectOn) {
                    this.$message.warning('请选择至少一门学科')
                    return
                }
            }
            this.saveLock = true
            requestApi.save(this.info)
            .then(res => {
                if(res.Success) {
                    this.$message.success('操作成功')
                    if(this.PAGEKEY === 'courseRankAdd') {
                        this.closePage()
                    }
                } else {
                    this.$message.error(res.Msg)
                }
            }).finally(e => {
                this.saveLock = false
            })
        },
        deleteCover() {
            this.info.coverImg = ''
        },
        // 打开课程弹框
        openCourse() {
            this.$refs.courseRelate.open("选择课程")
        },
        choiceCourseCallback(courseList) {
            this.relation(courseList)
        },
        remove(item) {
            this.$confirm('确认要删除吗？',
                '删除提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                requestApi.deleteRelation({
                    id: this.rankId,
                    courseId: item.courseId
                }).then(res => {
                    if(res.Success){
                        this.$message.success('删除成功！')
                        this.courseList = res.Data
                    }else{
                        this.$message.error(res.Msg)
                    }
                }).catch(res => {
                    this.$message.error('删除失败！')
                })
            }).catch((res) => {
                console.log(res)
            })
        },
        closePage() {
            this.$store.dispatch('tabs/removeSpecifiedTab', this.PAGEKEY)
            this.$store.dispatch('tabs/toTargetTab', this.PAGEBACK)
        },
        blur() {
            console.log('blur')
        },
        change(currentValue, oldValue, row) {
            requestApi.changeRank({
                id: this.rankId,
                courseId: row.courseId,
                rank: currentValue
            }).then(res => {
                if (res.Success) {
                    this.$message.success('排行修改成功')
                } else {
                    row.sortIndex = oldValue
                    this.$message.error(res.Msg)
                }
            })
        }
    },
    filters: {
        priceFilter(val){
            if(!val) { return 0 }
            return parseFloat((val/100).toFixed(1))
        }
    }
}
</script>

<style scoped>
.wrap{
    padding-top: 20px;
}
.input-width{
    width: 400px;
}
</style>


// WEBPACK FOOTER //
// src/views/operateManage/courseRank/components/page.vue